export default {
  namespaced: true,
  state: {
    payments: [], // переводы баллов на карты или телефон.
    repeatPrefill: null, // параметры платежа, перенесённые в форму создания по кнопке «Повторить».
  },
  getters: {
  },
  actions: {
    GetPayments({ commit, rootGetters, dispatch }, id) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('payments/api-v3/payments/by-profile', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'payments', value: response.data.payments });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    // Carries a source payment's parameters to the creation form so «Повторить»
    // reopens it prefilled; the participant still confirms via «Перевести».
    SetRepeatPrefill({ commit }, payload) {
      commit('setField', { name: 'repeatPrefill', value: payload });
    },
    ClearRepeatPrefill({ commit }) {
      commit('setField', { name: 'repeatPrefill', value: null });
    },
    InitialStorePayments({ commit }) {
      commit('setField', { name: 'payments', value: [] });
      commit('setField', { name: 'repeatPrefill', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
